import React from "react";
import AccountBalanceRoundedIcon from "@mui/icons-material/AccountBalanceRounded";
import { BANKS_URL, DELETE_BANK, SAVE_BANK } from "../../../API/APIRoutes";
import GenericItemsListing from "../ListingItems/ListingItems";
import ItemValidationSchema from "@Utils/Validations/ItemValidationSchema";

function BanksListing() {
  const attributes = [{ key: "bankName", label: "Bank Name", flex: 2 }];

  const validationSchema = ItemValidationSchema(attributes[0].key,attributes[0].label);

  return (
    <GenericItemsListing
      items_URL={BANKS_URL}
      SAVE_Item={SAVE_BANK}
      DELETE_Item={DELETE_BANK}
      title="Banks"
      name="Bank"
      icon={<AccountBalanceRoundedIcon fontSize="large" color="white" />}
      attributes={attributes}
      validationSchema={validationSchema}
      uniqueId={"bankId"}
    />
  );
}

export default BanksListing;
